import * as React from 'react';
import SubcategoryModel from 'src/model/subcategory.model';

import './Subcategory.scss';
import { categoryUrl } from 'src/utils/navigation';

interface ISubcategoryProps {
  action?: any;
  subcategory: SubcategoryModel;
  active: boolean;
}

export default function Subcategory(props: ISubcategoryProps) {
  return (
    <a
      href={categoryUrl(props.subcategory.category.id, props.subcategory.id)}
      className={`rp-subcategory ${props.active ? 'active' : ''}`}
      onClick={() => {
        props.action(props.subcategory.id);
      }}
    >
      {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && props.subcategory.frName!== null 
            ?props.subcategory.frName
            :props.subcategory.name}
    </a>
  );
}
